import { Routes } from '@angular/router';
import { NotFoundComponent } from './modules/static-page/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth-routing.module').then(m => m.routes),
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./modules/user/user-routing.module').then(m => m.routes),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard-routing-module').then(m => m.routes),
  },
  {
    path: 'calendar',
    loadChildren: () =>
      import('./modules/calendar/calendar-routing-module').then(m => m.routes),
  },
  {
    path: 'objects',
    loadChildren: () =>
      import('./modules/object/object-routing-module').then(m => m.routes),
  },
  {
    path: 'tasks',
    loadChildren: () =>
      import('./modules/tasks/tasks-routing.module').then(m => m.routes),
  },
  {
    path: 'cleaning',
    loadChildren: () =>
      import('./modules/cleaning/cleaning-routing.module').then(m => m.routes),
  },
  {
    path: 'calendar-sync',
    loadChildren: () =>
      import('./modules/calendar-sync/calendar-sync-routing.module').then(m => m.routes),
  },
  {
    path: 'guest-info',
    loadChildren: () =>
      import('./modules/guest-info/guest-info-routing.module').then(m => m.routes),
  },
  {
    path: 'conversations',
    loadChildren: () =>
      import('./modules/conversations/conversations.routes').then(m => m.routes),
  },
  {
    path: 'content-generator',
    loadChildren: () =>
      import('./modules/content-generator/content-generator-routing.module').then(m => m.routes),
  },
  {
    path: 'municipal-info',
    loadChildren: () =>
      import('./modules/municipal-info/municipal-info-routing.module').then(m => m.routes),
  },
  {
    path: 'domains',
    loadChildren: () =>
      import('./modules/domains/domains-routing.module').then(m => m.routes),
  },
  {
    path: 'bot',
    loadChildren: () =>
      import('./modules/messaging-bot/messaging-bot-routing.module').then(m => m.routes),
  },
  {
    path: 'embed',
    loadChildren: () =>
      import('./modules/embed/embed-routing.module').then(m => m.routes),
  },
  {
    path: 'reviews',
    loadChildren: () =>
      import('./modules/reviews/reviews-routing.module').then(m => m.routes),
  },
  {
    path: 'leads',
    loadChildren: () =>
      import('./modules/leads/leads-routing.module').then(m => m.routes),
  },
  {
    path: 'plans',
    loadChildren: () =>
      import('./modules/plans/plans-routing.module').then(m => m.routes),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./modules/settings/settings-routing.module').then(m => m.routes),
  },
  {
    path: 'consents',
    loadChildren: () =>
      import('./modules/consents/consents-routing.module').then(m => m.routes),
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent },
];
